import React from 'react';

import LeafPage from '../components/leaf-page';

class LeafPagePage extends React.Component {

  render() {
    return (
      <div>
        <LeafPage/>
      </div>
    )
  }
}

export default LeafPagePage;


// WEBPACK FOOTER //
// ./src/containers/leaf-page-page.js